<template>
  <div>
    <v-container @keyup.enter="emitEventCalcular()">
      <v-row>
        <v-col cols="12">
          <h1
            class="page-form-title h2"
          >Simule quantos leads precisam ser gerados no seu funil de vendas</h1>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <div class="app-subtitle">
            <div>Preencha os valores abaixo de acordo com a realidade atual do seu pipeline.</div>
            <div>Veja o cálculo ao lado sendo gerado automaticamente e descubra quantos leads precisam ser gerados para atingir a sua meta</div>
          </div>
        </v-col>
      </v-row>

      <form id="funnelValuesForm">
        <v-row class="pa-0 mt-3">
          <v-col cols="12" class="form-title">Meta mensal</v-col>
        </v-row>

        <v-row class="pt-0">
          <v-col cols="12" md="5" class="pt-0 pb-0">
            <v-text-field
              label="Valor"
              v-model="inputValorMeta"
              v-money="moneyMask"
              prefix="R$"
              outlined
              placeholder="0"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pt-0 pb-0">
            <v-text-field
              label="Ticket médio"
              v-model="inputTicketMedio"
              v-money="moneyMask"
              prefix="R$"
              outlined
              placeholder="0"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-6">
          <v-col>
            <div
              class="form-label mb-2 mb-1"
            >Quantas propostas são necessárias para fechar uma venda?</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              label="Insira a quantidade"
              v-model="propostasPorVenda"
              type="number"
              min="0"
              outlined
              hide-details
              v-on:input="emitInputChange('propostasPorVenda', propostasPorVenda)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-6">
          <v-col>
            <div
              class="form-label mb-2"
            >Quantas demonstrações são necessárias para gerar uma proposta?</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              label="Insira a quantidade"
              v-model="demosPorProposta"
              type="number"
              min="0"
              outlined
              hide-details
              v-on:input="emitInputChange('demosPorProposta', demosPorProposta)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-6">
          <v-col>
            <div
              class="form-label mb-2"
            >Quantas oportunidades quentes são necessárias para gerar uma demo?</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              label="Insira a quantidade"
              v-model="oportunidadesPorDemo"
              type="number"
              min="0"
              outlined
              hide-details
              v-on:input="emitInputChange('oportunidadesPorDemo', oportunidadesPorDemo)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-6">
          <v-col>
            <div
              class="form-label mb-2"
            >Para gerar uma oportunidade, qual quantidade de leads devem ser contatados?</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              label="Insira a quantidade"
              v-model="leadsPorOportunidade"
              type="number"
              min="0"
              outlined
              v-on:input="emitInputChange('leadsPorOportunidade', leadsPorOportunidade)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-1" justify="end">
          <v-col cols="4" md="4">
            <div class="d-flex justify-end">
              <v-btn
                color="#fe5c82"
                x-large
                class="mr-4 wrapper-next-button button-calcular"
                @click="emitEventCalcular()"
              >CALCULAR</v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </v-container>

    <transition name="slide-fade">
      <v-alert
        v-if="showErrorAlert"
        class="ecdt-alert"
        type="error"
        elevation="5"
        dismissible
      >{{errorAlertText}}</v-alert>
    </transition>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import './../App.css'

export default {
  directives: { money: VMoney },
  props: {
    showErrorAlert: { type: Boolean, default: false },
    errorAlertText: String
  },
  data: function() {
    return {
      inputTicketMedio: null,
      inputValorMeta: null,
      propostasPorVenda: null,
      demosPorProposta: null,
      oportunidadesPorDemo: null,
      leadsPorOportunidade: null,

      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  methods: {
    emitInputChange(fieldName, value) {
      this.$emit('input-change', fieldName, value)
    },
    emitEventCalcular() {
      const inputFields = {
        inputTicketMedio: this.parseMoneyToFloat(this.inputTicketMedio),
        inputValorMeta: this.parseMoneyToFloat(this.inputValorMeta),
        propostasPorVenda: this.propostasPorVenda,
        demosPorProposta: this.demosPorProposta,
        oportunidadesPorDemo: this.oportunidadesPorDemo,
        leadsPorOportunidade: this.leadsPorOportunidade
      }
      this.$emit('calcular', inputFields)
    },
    parseMoneyToFloat(str) {
      if (!str) {
        return 0
      }
      const strWithoutDotsOnThousands = str.split('.').join('')
      const strChangedCommaToDot = strWithoutDotsOnThousands
        .split(',')
        .join('.')
      return parseFloat(strChangedCommaToDot)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;700&display=swap');
.page-form-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2.75rem;
  font-weight: bold;
}
.form-title {
  font-size: 26px;
  font-weight: bold;
  color: #3300cc;
}
.form-label {
  font-size: 14px;
  font-weight: bold;
  color: #3300cc;
}

.button-calcular {
  border-radius: 0;
  color: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.ecdt-alert {
  position: fixed;
  top: 0;
  width: 99.2vw;
  left: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>